<script lang="ts">
</script>

<div class="mb-5 pb-5 sm:mb-7 sm:pb-7 border-b border-general text-3xl sm:text-4xl font-semibold">
  <slot />
</div>
